import React, { Fragment, useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { useLocation, useNavigate } from "react-router-dom";
import { ButtonModalFormSaveClose } from "./ButtonModalSelection";

const UpdatePassword = ({ user, onComplete, close }) => {
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(false);
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [password, setPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [passwordRejectReason, setPasswordRejectReason] = useState(null);
  const [confirmPasswordRejectReason, setConfirmPasswordRejectReason] =
    useState(null);
  const [passwordValid, setPasswordValid] = useState(false);
  const [confirmPasswordValid, setConfirmPasswordValid] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const pvalid =
      password !== null &&
      password !== undefined &&
      password !== "" &&
      password.length > 0;
    const cvalid =
      confirmPassword !== null &&
      confirmPassword !== undefined &&
      confirmPassword !== "" &&
      confirmPassword === password &&
      confirmPassword?.length > 0;

    setPasswordValid(pvalid);
    setConfirmPasswordValid(cvalid);

    if (!pvalid) setPasswordRejectReason("invalid password");
    if (!cvalid) setConfirmPasswordRejectReason("password does not match");
  }, [password, confirmPassword]);

  useEffect(() => {
    const validForm = passwordValid && confirmPasswordValid;
    setSaveDisabled(!validForm);
  }, [passwordValid, confirmPasswordValid]);

  const onSave = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);

      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: {},
      };

      const response = await authAxios().post(
        "/api/backoffice/users/update_password",
        { userId: user?.id, password: password },
        config,
      );
      setLoading(false);

      if (onComplete !== null && onComplete !== undefined)
        onComplete(response.data);

      const newUserId = response.data.id;
      const newUser = "/users/" + newUserId;
      navigate(newUser, { replace: true });

      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log("error:");
      console.log(err);
    }
  };

  const passwordChanged = (value) => {
    var text = value.target.value;
    setPassword(text);
  };

  const confirmPasswordChanged = (value) => {
    var text = value.target.value;
    setConfirmPassword(text);
  };

  return (
    <Fragment>
      <Form onSubmit={onSave}>
        <Form.Group className="mb-3" controlId="formPassword">
          <Row>
            <Col xs lg="2">
              <Form.Label>Password</Form.Label>
            </Col>
            <Col xs lg="4">
              <Form.Control
                type="password"
                value={password}
                onChange={passwordChanged}
                isValid={passwordValid}
                isInvalid={!passwordValid}
                required
              />
              <Form.Control.Feedback type="invalid">
                {passwordRejectReason}
              </Form.Control.Feedback>
            </Col>
          </Row>
        </Form.Group>
        <Form.Group className="mb-3" controlId="formConfirmPassword">
          <Row>
            <Col xs lg="2">
              <Form.Label>Confirm Password</Form.Label>
            </Col>
            <Col xs lg="4">
              <Form.Control
                type="password"
                value={confirmPassword}
                onChange={confirmPasswordChanged}
                isValid={confirmPasswordValid}
                isInvalid={!confirmPasswordValid}
                required
              />
              <Form.Control.Feedback type="invalid">
                {confirmPasswordRejectReason}
              </Form.Control.Feedback>
            </Col>
          </Row>
        </Form.Group>

        <ButtonModalFormSaveClose
          saveName={"Save"}
          close={close}
          formSave={onSave}
          loading={saveDisabled}
        />
      </Form>
    </Fragment>
  );
};

export default UpdatePassword;
